module.exports = __webpack_public_path__ + "img/image (22).15cafe4b.png";